import { makeStyles } from '@material-ui/core/styles'

export const getVariant = variant => {
  if (variant === `Title_1`) {
    return `h1`
  }
  if (variant === `Title_2`) {
    return `h2`
  }
  if (variant === `Parrafo`) {
    return `body1`
  }
  return variant
}
export const pixelToRem = string => {
  return string
}

export const useStyles = makeStyles({
  Title_1: ({
    palette,
    color = `letra`,
    weight = `bold`,
    breakpoints,
    backgroundColor,
    sizeMovile = `2.4rem`,
  }) => ({
    fontSize: `4.5rem`,
    fontWeight: weight,
    lineHeight: `4.5rem`,
    color: palette[color],
    backgroundColor: palette[backgroundColor],
    [breakpoints.down(`1280`)]: {
      fontSize: pixelToRem(sizeMovile),
      lineHeight: `2.8rem`,
    },
  }),
  Title_1_About: ({
    palette,
    color = `letra`,
    weight = `bold`,
    breakpoints,
    backgroundColor,
    sizeMovile = `2.4rem`,
  }) => ({
    fontSize: `5rem`,
    fontWeight: weight,
    lineHeight: `4.5rem`,
    color: palette[color],
    backgroundColor: palette[backgroundColor],
    [breakpoints.down(`1280`)]: {
      fontSize: pixelToRem(sizeMovile),
      lineHeight: `2.8rem`,
    },
  }),
  Title_2: ({ palette, breakpoints, weight = `bold`, color = `font`, sizeMovile = `2.4rem` }) => ({
    fontSize: `3.8rem`,
    fontWeight: weight,
    lineHeight: `4.0rem`,
    letterSpacing: `-0.209302px`,
    color: palette[color],
    [breakpoints.down(`1280`)]: {
      fontSize: pixelToRem(sizeMovile),
      lineHeight: `2.8rem`,
    },
  }),
  BigTitle: ({
    palette,
    color = `letra`,
    weight = `bold`,
    breakpoints,
    backgroundColor,
    sizeMovile = `2.4rem`,
  }) => ({
    fontSize: `6.5rem`,
    fontWeight: weight,
    lineHeight: `7.9rem`,
    color: palette[color],
    backgroundColor: palette[backgroundColor],
    [breakpoints.down(`1280`)]: {
      fontSize: `5rem`,
      lineHeight: `6.2rem`,
    },
    [breakpoints.down(`960`)]: {
      fontSize: pixelToRem(sizeMovile),
      lineHeight: `4.8rem`,
    },
  }),
  h1: ({ palette, breakpoints, weight = `bold`, sizeMovile = `2.4rem`, color = `letra` }) => ({
    letraSize: `20px`,
    fontWeight: weight,
    lineHeight: `3.5rem`,
    color: palette[color],
    [breakpoints.down(`1280`)]: {
      fontSize: pixelToRem(sizeMovile),
      lineHeight: `2.8rem`,
    },
  }),
  h2: ({ palette, breakpoints, weight = `bold`, sizeMovile = `2.2rem`, color = `letra` }) => ({
    fontSize: `18px`,
    fontWeight: weight,
    lineHeight: `18px`,
    color: palette[color],
    [breakpoints.down(`1280`)]: {
      fontSize: pixelToRem(sizeMovile),
      lineHeight: `2.5rem`,
    },
  }),
  h3: ({ palette, breakpoints, weight = `bold`, sizeMovile = `2rem`, color = `letra` }) => ({
    fontSize: 14,
    fontWeight: weight,
    lineHeight: `2.5rem`,
    color: palette[color],
    [breakpoints.down(`1280`)]: {
      fontSize: pixelToRem(sizeMovile),
      lineHeight: `2.2rem`,
    },
  }),
  h4: ({ palette, breakpoints, weight = `bold`, sizeMovile = `1.8rem`, color = `letra` }) => ({
    fontSize: 12,
    fontWeight: weight,
    lineHeight: `12px`,
    color: palette[color],
    [breakpoints.down(`1280`)]: {
      fontSize: `${pixelToRem(sizeMovile)} !important`,
      lineHeight: `2.0rem !important`,
    },
  }),
  h5: ({ palette, breakpoints, weight = `bold`, sizeMovile = `1.6rem`, color = `letra` }) => ({
    fontSize: 10,
    fontWeight: weight,
    lineHeight: `10px`,
    color: palette[color],
    [breakpoints.down(`1280`)]: {
      fontSize: pixelToRem(sizeMovile),
      lineHeight: `1.8rem`,
    },
  }),
  body1: ({
    palette,
    breakpoints,
    weight = `bold`,
    sizeMovile = `1.4rem`,
    textDecoration = `inherit`,
    color = `font`,
    letterSpacing,
  }) => ({
    fontSize: `1.6rem`,
    fontWeight: weight,
    lineHeight: `1.8rem`,
    textDecoration,
    letterSpacing,
    color: palette[color],
    [breakpoints.down(`1280`)]: {
      fontSize: pixelToRem(sizeMovile),
      lineHeight: `1.6rem`,
    },
  }),
  body2: ({ palette, breakpoints, weight = `bold`, sizeMovile = `1.2rem` }) => ({
    fontSize: `1.4rem`,
    fontWeight: weight,
    lineHeight: `1.6rem`,
    color: palette.font,
    [breakpoints.down(`1280`)]: {
      fontSize: pixelToRem(sizeMovile),
      lineHeight: `1.4rem`,
    },
  }),
  Parrafo: ({
    palette,
    color,
    size,
    sizeMovile = 14,
    weight,
    breakpoints,
    backgroundColor,
    minHeight,
    letterSpacing,
  }) => ({
    fontSize: pixelToRem(size),
    fontWeight: weight,
    letterSpacing,
    minHeight,
    lineHeight: `${size + 2}px`,
    color: palette[color],
    backgroundColor: palette[backgroundColor],
    [breakpoints.down(`1280`)]: {
      fontSize: pixelToRem(sizeMovile),
      lineHeight: `${sizeMovile + 2}px`,
    },
    [breakpoints.down(`1100`)]: {
      fontSize: pixelToRem(sizeMovile - 3),
      lineHeight: `${sizeMovile + 2}px`,
    },
    [breakpoints.down(`670`)]: {
      fontSize: pixelToRem(sizeMovile - 2),
      lineHeight: `${sizeMovile + 2}px`,
    },
  }),
  Link: ({ palette, color, size, weight, minHeight, marginTopLink = 10 }) => ({
    marginTop: marginTopLink,
    fontSize: pixelToRem(size),
    fontWeight: weight,
    minHeight,
    lineHeight: `${size}px`,
    color: palette[color],
    textDecorationLine: `underline`,
    '&:hover': {
      cursor: `pointer`,
    },
  }),
  ParrafoBanner: ({
    palette,
    color,
    size,
    sizeMovile = 14,
    weight,
    breakpoints,
    backgroundColor,
    minHeight,
    letterSpacing,
  }) => ({
    fontSize: pixelToRem(size),
    fontWeight: weight,
    letterSpacing,
    minHeight,
    lineHeight: `${size + 2}px`,
    color: palette[color],
    backgroundColor: palette[backgroundColor],
    [breakpoints.down(`1280`)]: {
      fontSize: pixelToRem(sizeMovile),
      lineHeight: `${sizeMovile + 2}px`,
    },
    [breakpoints.down(`1100`)]: {
      fontSize: pixelToRem(sizeMovile - 3),
      lineHeight: `16px`,
    },
    [breakpoints.down(`600`)]: {
      fontSize: pixelToRem(sizeMovile),
      lineHeight: `18px`,
    },
  }),
})
